import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Tooltip } from 'antd';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { bookingJourneyType } from 'common/constants/booking';
import { BookingListLink } from 'common/components/svgs';
import useStyles from './style';

export default function CardGroup({ className, propertyData, data }) {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const handleGotoPropertyList = ev => {
    const bookingJourneys = ev.currentTarget?.dataset?.type;
    let search = `?bookingJourneys=${bookingJourneys}`;

    if (bookingJourneys === bookingJourneyType.MANUAL) {
      search += `&bookingJourneys=${bookingJourneyType.FULL_AUTOMATIC}`;
    }

    if (bookingJourneys) {
      history.push({
        pathname: '/properties',
        search,
      });
    }
  };

  const bookingType = [
    {
      type: bookingJourneyType.SEMI_AUTOMATIC,
      className: 'herculesCard',
      title: 'landlord.long_tail.booking.list.hercules_booking_title',
      subtitle: 'landlord.long_tail.booking.list.hercules_booking_subTitle',
      weeklyStatus: 'landlord.long_tail.booking.list.pending_confirmation',
      propertyNumberFiled: 'herculesProperty',
      allBookingNumberField: 'herculesAllOrders',
      weeklyBookingNumberField: 'herculesWeeklyOrders',
    },
    {
      type: bookingJourneyType.INSTANT_BOOK,
      className: 'automationCard',
      title: 'landlord.long_tail.booking.list.instant_bookings',
      subtitle: 'landlord.long_tail.booking.list.instant_bookings_subTitle',
      weeklyStatus: 'landlord.long_tail.booking.list.in_progress',
      propertyNumberFiled: 'instantProperty',
      allBookingNumberField: 'instantAllOrders',
      weeklyBookingNumberField: 'instantWeeklyOrders',
    },
  ].filter(booking => data?.company?.[booking.allBookingNumberField]?.['totalCount'] > 0);

  return (
    <div
      className={classnames(classes.container, className, {
        'card--container__one': bookingType.length === 1,
        'card--container__two': bookingType.length === 2,
        'card--container__three': bookingType.length === 3,
      })}
    >
      <For each="booking" of={bookingType}>
        <div
          className={classnames(classes.card, classes[booking.className], 'card-item')}
          key={booking?.type}
        >
          <div className={classnames(classes.cardTitleGroup, 'card--title__group')}>
            <h4>
              {t(booking.title)}
              <Tooltip
                title={t('landlord.long_tail.booking.list.tooltip', {
                  number: propertyData[booking.propertyNumberFiled]?.['totalCount'] ?? 0,
                  type: booking.type,
                })}
              >
                <BookingListLink
                  className={classnames(classes.cardLink, 'card--link')}
                  data-type={booking.type}
                  onClick={handleGotoPropertyList}
                />
              </Tooltip>
            </h4>
            <p>{t(booking.subtitle)}</p>
          </div>
          <div className={classnames(classes.cardMainStatistics, 'card--main__statistics')}>
            <div className="card--main__total-bookings">
              <h1>{data['company']?.[booking.allBookingNumberField]?.['totalCount'] ?? 0}</h1>
              <p>{t('landlord.long_tail.booking.list.all_bookings')}</p>
            </div>
            <If condition={booking.type !== bookingJourneyType.MANUAL}>
              <div className="card--main__weekly-bookings">
                <h1>{data['company']?.[booking.weeklyBookingNumberField]?.['totalCount'] ?? 0}</h1>
                <span>{t('landlord.long_tail.booking.list.weekly')}</span>
                <p>{t(booking.weeklyStatus)}</p>
              </div>
            </If>
          </div>
        </div>
      </For>
    </div>
  );
}

CardGroup.propTypes = {
  className: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};
